// extracted by mini-css-extract-plugin
module.exports = {"searchSponsoredProductsContainer":"Ug","product":"Vg","products":"Wg","tooltipWrapper":"Xg","tooltip":"Yg","title":"Zg","secondRow":"_g","firstRow":"ah"};